import { contractActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: {},
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case contractActions.CONTRACTS_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        error: null
      };
    case contractActions.CONTRACTS_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || {},
        error: action.error
      };
    case contractActions.CONTRACTS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null
      };
    default:
      return state;
  }
};
